import api from "./api";
import config from "../config";

export default {
  fetchBillingSummary(apiKey) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `billing/summary`,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  updateSettings(apiKey, body) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `billing/settings`,
          json: body,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchInvoicePreview(apiKey, { start, end }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `billing/invoice_preview`,
          json: {
            start,
            end
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  performAdjustment(apiKey, body) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `billing/adjustment`,
          json: body,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  pushInvoiceToStripe(apiKey, body) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "POST",
          endpoint: `billing/invoice_push_to_stripe`,
          json: body,
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  },

  fetchInvoicingHub(apiKey, { month }) {
    return new Promise((resolve, reject) => {
      api.request(
        {
          method: "GET",
          endpoint: `billing/invoicing_hub`,
          qs: {
            month
          },
          api_key: apiKey
        },
        function (err, response) {
          if (err) {
            return reject(err);
          }
          resolve(response);
        }
      );
    });
  }
};



// WEBPACK FOOTER //
// ./src/app/utils/BillingUtil.js